import React, { useState, useEffect } from "react";
import _, { filter } from "lodash";
import {
  _getSelectedOptionActivity,
  _getBaseUrl,
  _isFirstRender,
  _getCSRFTokenValue,
} from "../utils/helper";
import api from "../utils/api";
import { apiToken, accesspassBaseURL } from "../utils/api";
import { Loader, Pagination } from "../atoms";
import { FilterDropDown, KeywordSearch } from "../forms";
import { ActivityCard } from "../cards";
import StateView from "../utils/StateView";

let INITIAL_VALUES = {
  gebieden: [],
  onderwerpen: [],
  skip: 0,
  take: 10,
  nodeType: "",
  group: "",
  keywords: [],
};

const ActiviteitenPast = (props) => {
  const [filterOptions, setFilterOptions] = useState([]);
  const [values, setValues] = useState(INITIAL_VALUES);
  const [posts, setPosts] = useState([]);
  const [totalPosts, setTotalPosts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [tags, setTags] = useState([]);
  const [isFiltersExpanded, setIsFiltersExpanded] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [visiblePosts, setVisiblePosts] = useState(4);

  const isFirstLoad = _isFirstRender();
  const nodeType = props?.data["node-type"] || "";
  const group = props?.data["group"] || "";

  // console.log("apiT", apiToken());
  // console.log("url", accesspassBaseURL());

  useEffect(() => {
    fetchFilters();

    const urlParams = new URLSearchParams(window.location.search);
    const keyword = decodeURIComponent(urlParams.get("keyword"));
    const topic = decodeURIComponent(urlParams.get("topic"));

    if (keyword !== null && keyword !== "" && keyword !== "null") {
      setValues({ ...INITIAL_VALUES, ["keywords"]: [keyword], ["skip"]: 0 });
      addRemoveTags("keywords", keyword, true);
      return;
    }

    if (topic !== null && topic !== "" && topic !== "null") {
      setValues({ ...INITIAL_VALUES, ["topics"]: [topic], ["skip"]: 0 });
      return;
    }

    // setValues({ ...INITIAL_VALUES, ["nodeType"]: nodeType, ["group"]: group });

    // if (nodeType === "actueel") {
    setValues({ ...INITIAL_VALUES, ["take"]: 12, ["nodeType"]: nodeType });
    // }

    // fetchPosts();
  }, []);

  useEffect(() => {
    if (!isFirstLoad) {
      fetchPosts();
    }
  }, [values]);

  const fetchFilters = () => {
    setIsLoadingFilters(true);

    api
      .get("/filterlistoptions")
      .then((res) => {
        setIsLoadingFilters(false);
        setFilterOptions(res.data);

        const urlParams = new URLSearchParams(window.location.search);
        const topic = decodeURIComponent(urlParams.get("topic"));

        if (topic !== null && topic !== "" && topic !== "null") {
          addRemoveTags("topics", topic, true);
        }
      })
      .catch(() => {
        setIsLoadingFilters(false);
      });
  };

  const fetchPosts = async () => {
    setIsLoadingPosts(true);

    const csrfToken = await _getCSRFTokenValue();
    const fields = values;

    // console.log("catchvalue", values);

    const url = accesspassBaseURL() + "/api/event/list/archive";
    // const url = accesspassBaseURL() + "/api/event/list/now";
    // const url = accesspassBaseURL() + "/api/event/archive/now";
    const token = apiToken();

    api.post(url, {}, {
      headers: {
        "Api-Token": token,
        "Content-Type": "application/json",
      },
    })
      // .then((res) => {
      //   console.log("post results", res);
      //   setIsLoadingPosts(false);
      //   setPosts(res.data.result.data);
      //   // setTotalPosts(res.data.totalNodes);
      //   setTotalPosts(res.data.result.data.length);
      // })
      .then((res) => {
        // console.log("post results", res);
        setIsLoadingPosts(false);

        const posts = res.data.result.data;
        // console.log("post results", posts);

        const filterGebieden = fields.gebieden;
        const filterOnderwerpen = fields.onderwerpen;
        const filterKeyword = fields.keywords;

        if (filterGebieden.length > 0 || filterOnderwerpen.length > 0 || filterKeyword.length > 0) {

          const postWithOnder = posts.filter(post =>
            post.onderwerpen.some(onderwerp => filterOnderwerpen.includes(onderwerp))
          );

          const postWithGeb = posts.filter(post =>
            post.gebieden.some(gebied => filterGebieden.includes(gebied))
          );

          const postWithKeyword = posts.filter(post =>
            filterKeyword.some(keyword => post.title.toLowerCase().includes(keyword.toLowerCase()))
          );


          // Combine both arrays, removing duplicates
          const combinedPosts = [...new Set([...postWithOnder, ...postWithGeb, ...postWithKeyword])];

          console.log('filtered posts', combinedPosts);
          // console.log("resultonder", postWithOnder);
          // console.log("resultgeb", postWithGeb);

          // console.log("filterss apllied");

          setPosts(combinedPosts);
          setTotalPosts(combinedPosts.length);
        } else {
          // console.log("allll");
          // console.log("post results", posts);
          setPosts(res.data.result.data);
          setTotalPosts(res.data.result.data.length);
        }
      })

      .catch(() => {
        setIsLoadingPosts(false);
      });
  };

  const loadMore = () => {
    setVisiblePosts((prev) => prev + 4); // Load 4 more posts each time
  };

  const updateFilters = (key, value) => {
    let filters = { ...values, [key]: value, skip: 0 };

    // console.log("pp", filters);
    // this buddy sets the catchvalues

    setCurrentPage(1);
    setValues(filters);
  };

  const addRemoveTags = (filter, value, addRemove) => {
    let temp = [...tags];

    if (addRemove) {
      temp.push({
        filter,
        value,
      });
    } else {
      temp = temp.filter((item) => !(item.filter === filter && item.value === value));
    }

    setTags(temp);
  };

  const onFilterChanged = (filter, value, checked) => {
    let updatedValue = [...values[filter]];

    if (checked) {
      addRemoveTags(filter, value, true);
      updatedValue.push(value);
      // console.log("iiiccc", updatedValue);
    } else {
      addRemoveTags(filter, value, false);
      updatedValue = updatedValue.filter((item) => item !== value);
      // console.log("iiixxx", updatedValue);
    }

    // console.log("fil1", filter);
    // console.log("fil2", updatedValue);

    updateFilters(filter, updatedValue);
    setIsFilter(true);
  };

  const onKeyUpHandler = (e) => {
    if (e.key === "Enter") {
      const keyword = e.target.value;
      setSearchValue(keyword);
      const isWhitespaceString = !keyword.replace(/\s/g, "").length;

      if (isWhitespaceString) {
        return;
      }

      let updatedKeywords = [...values.keywords];

      if (updatedKeywords.indexOf(keyword) >= 0) {
        return;
      }

      updatedKeywords.push(keyword);

      updateFilters("keywords", updatedKeywords);
      addRemoveTags("keywords", keyword, true);
      setIsFilter(true);

      e.target.value = "";
    }
  };

  const removeKeyword = (keyword) => {
    let updatedKeywords = [...values.keywords];

    updatedKeywords = updatedKeywords.filter((item) => item !== keyword);

    updateFilters("keywords", updatedKeywords);
    addRemoveTags("keywords", keyword, false);

    if (updatedKeywords.length === 0) {
      setSearchValue("");
    }
  };

  const clearFilters = () => {
    setSearchValue("");
    setValues({
      ...INITIAL_VALUES,
      nodeType: values.nodeType,
      group: values.group,
    });
    setTags([]);
    setIsFilter(false);
  };

  const navigatePage = (goNext) => {
    let page;
    let skip;

    if (goNext) {
      page = currentPage + 1;
    } else {
      page = currentPage - 1;
    }

    skip = (page - 1) * values.take;

    setValues({ ...values, skip });
    setCurrentPage(page);
  };

  // console.log(filterOptions);

  return (
    <React.Fragment>

      {/* <div className="container">

        <div className="w-full xl:w-3/5 md:grid md:grid-cols-3 gap-4">
          <KeywordSearch
            placeholder="Zoek"
            onKeyUp={onKeyUpHandler}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />

          <div className="w-full pt-4 md:pt-0 flex justify-between md:justify-start gap-4 md:col-span-2">
            <FilterDropDown
              placeholder="onderwerpen"
              filter="onderwerpen"
              options={filterOptions.onderwerpen}
              onChange={onFilterChanged}
              value={values.onderwerpen}
              nodeType={nodeType}
              trayClass="w-full mt-2"
            />

            <FilterDropDown
              placeholder="gebieden"
              filter="gebieden"
              options={filterOptions.gebieden}
              onChange={onFilterChanged}
              value={values.gebieden}
              nodeType={nodeType}
              trayClass="w-full mt-2"
            />

          </div>


        </div>

        {tags.length > 0 && isFilter && (
          <div className="py-4">
            <h2 className="text-lg mb-3 font-semibold">
              Toegepaste filters
            </h2>
            <div className="filter-tags--wrapper flex flex-wrap gap-1">
              {tags.map((item) => {

                if (item.filter === "keywords") {

                  return (
                    <div className="filter-tag" key={item.value}>
                      <span>{item.value}</span>
                      <div
                        className="filter-tag--remove"
                        onClick={() => removeKeyword(item.value)}
                      ></div>
                    </div>
                  );
                } else {
                  return (
                    <div
                      className="filter-tag"
                      tabIndex={0}
                      key={`${item.filter}-${item.value}`}
                      onClick={() => onFilterChanged(item.filter, item.value, false)}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          onFilterChanged(item.filter, item.value, false);
                        }
                      }}
                    >
                      <span>
                        {_getSelectedOptionActivity(
                          filterOptions[item.filter],
                          item.value,
                          true
                        ).label}

                      </span>
                      <div className="filter-tag--remove"></div>
                    </div>
                  );
                }
              })}
              <div
                className="filter-tag clear cursor-pointer"
                onClick={() => clearFilters()}
                onKeyDown={(event) => {
                  if (event.key === "Enter") clearFilters();
                }}
                tabIndex={0}
              >
                <span>Alles wissen</span>
              </div>
            </div>
          </div>
        )}

      </div> */}

      <div className="py-8">
        <div className="container">
          <div className="my-8">
            {isLoadingPosts && <Loader className="mb-8" />}

            <h2 className="h1 mb-8 md:mb-4">
              Afgelopen
            </h2>
            {/*
            <div className="text-center text-xl md:text-2xl lg:text-3xl mb-8 md:mb-4">
              {totalPosts} resultaten
            </div> */}

            {_.isArray(posts) && posts.length > 0 ? (
              <React.Fragment>
                {/* <div className="grid grid-cols-1 items-center gap-8 py-8">
                  {posts.map((post, index) => (
                    <ActivityCard key={index} data={post} index={index} nodeType={nodeType} />
                  ))}
                </div> */}

                <ul className="grid grid-cols-1 items-center gap-8 py-8 list-none">
                  {posts.slice(0, visiblePosts).map((post, index) => (
                    <ActivityCard key={index} data={post} index={index} nodeType={nodeType} />
                  ))}
                </ul>

                {/* <div className="slider-control flex gap-4 md:gap-8 items-center justify-center my-12">
                  <button
                    className={`prev rotate-180 nav-icon-after-white text-base gap-7 align-bottom w-full md:w-auto max-w-[100px] py-2.5 px-2 md:px-6 rounded-full bg-black text-white border-black border hover:bg-white hover:text-black relative flex items-center justify-center cursor-pointer ${currentPage <= 1 && "opacity-70 pointer-events-none"
                      }`}
                    aria-label="Previous"
                    onClick={() => navigatePage(false)}
                  ></button>
                  <div className="count-wrap relative">
                    {currentPage} van {Math.ceil(totalPosts / values.take)}
                  </div>
                  <button
                    className={`next nav-icon-after-white text-base gap-7 align-bottom w-full md:w-auto max-w-[100px] py-2.5 px-2 md:px-6 rounded-full bg-black text-white border-black border hover:bg-white hover:text-black relative flex items-center justify-center cursor-pointer ${currentPage >= Math.ceil(totalPosts / values.take) &&
                      "opacity-70 pointer-events-none"
                      }`}
                    aria-label="Next"
                    onClick={() => navigatePage(true)}
                  ></button>
                </div> */}

                {visiblePosts < posts.length && (
                  <div className="flex justify-center mt-4">
                    <div className="btn w-full md:w-fit">
                      <button
                        className="button-gew inline-block text-center btn-large text-black text-[20px] uppercase overview-btn"
                        onClick={loadMore}>
                        Meer laden
                      </button>
                    </div>
                  </div>
                )}



              </React.Fragment>
            ) : isLoadingPosts ? null : (
              <p className="md:w-4/5">Op dit moment zijn er geen aankomende activiteiten. Blijf op de hoogte door je aan te melden voor onze nieuwsbrief en neem alvast een kijkje bij de afgelopen activiteiten!</p>
            )}
          </div>
        </div>
      </div>
      {/* {<State View title="values" values={values} className="bottom-4 left-4 right-[unset]" floating />} */}
      {/* {<StateView title="tags" values={tags} className="bottom-4 left-4 right-[unset]" floating />} */}
      {/* {<StateView title="posts" values={posts} className="top-4 right-4" floating collapsed/>} */}
      {/* {<StateView title="total posts" values={totalPosts} className="top-4 bottom-[unset] left-4 right-[unset]" floating />} */}
      {/* <StateView title="filters" values={filterOptions} className="bottom-4 right-96 max-h-[90vh] overflow-y-auto" floating /> */}
    </React.Fragment>
  );
};

export default ActiviteitenPast;
